import { createHead } from '@vueuse/head'
import { createApp as createClientApp } from 'vue'

import { router, setupRouter } from '/@/router'
import { setupStore } from '/@/store'

import BdApp from './App.vue'

import './styles'

export type BdAppContext = Awaited<ReturnType<typeof createApp>>
export type BdPlugin = (brandefense: BdAppContext) => void | Promise<void>

// get all plugins
const plugins = import.meta.glob<{ default: BdPlugin }>('./plugins/*.ts', { eager: true })

// this is a helper function to define plugins with autocompletion
export function definePlugin(plugin: BdPlugin) {
  return plugin
}

export async function createApp() {
  const app = createClientApp(BdApp)

  const head = createHead()
  app.use(head)

  const store = setupStore(app)

  setupRouter(app)

  const brandefense = {
    app,
    head,
    router,
    store,
  }

  app.provide('brandefense', brandefense)

  // add all plugins
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const path in plugins) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const { default: plugin } = await plugins[path]
      // eslint-disable-next-line no-await-in-loop
      await plugin(brandefense)
    } catch (error) {
      console.error(`Error while loading plugin "${path}".`)
      console.error(error)
    }
  }

  return brandefense
}
